module.exports = __webpack_public_path__ + "static/media/4_no.33c293af.png";